import { render } from "./SecretClientPlan.vue?vue&type=template&id=13d025c2&scoped=true"
import script from "./SecretClientPlan.vue?vue&type=script&lang=js"
export * from "./SecretClientPlan.vue?vue&type=script&lang=js"

import "./SecretClientPlan.vue?vue&type=style&index=0&id=13d025c2&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d025c2"]])

export default __exports__